<template>
  <div class="lipidlayerSetting">
    <h3>{{ $t("langcfg.txtShootingTime") }}</h3>
    <el-form :inline="false" class="demo-form-inline">
      <el-form-item :label="`${$t('langcfg.txtLipidLayer')}(${$t('langcfg.txtSecond')}):`">
        <el-select v-model="lipidlayertime" placeholder="">
          <el-option label="10" value="10"></el-option>
          <el-option label="150" value="150"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import EVENTS from "../../../bus";
import { saveCaptureSettings } from "../../../settings";
export default {
  name: "lipidlayerSetting",
  data() {
    return {
      lipidlayertime: window.captureSettings.lipidlayertime
    };
  },
  methods: {
    createCaptureSettingTool() {
      window.captureSettings.lipidlayertime = this.lipidlayertime;
      saveCaptureSettings(window.captureSettings);
    }
  },
  watch: {
    lipidlayertime() {
      this.createCaptureSettingTool();
      this.$bus.$emit(EVENTS.lapidlayerVideoTime, this.lipidlayertime);
    }
  }
};
</script>
<style lang="less" scoped>
.lipidlayerSetting {
  .demo-form-inline {
    margin-top: 30px;
  }
  margin-top: 30px;
  margin-left: 40px;
  /deep/ .el-form-item__label {
    font-size: 28px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/LipidlayerSettings.vue